<template>
  <header>
    <div class="containerWrapper bannerEvent">
      <div class="bannerEvent__lft">
        <div class="navbarTop">
          <img src="../assets/syntax_logo.svg" alt="syntax logo 2021" />
        </div>
        <p class="hero-timing">20-22 August 2021</p>
        <h1 class="hero-heading">
          Talking Tech for the
          <span class="text-outline">Future</span>
        </h1>
        <div class="bannerEvent__register">
          <span class="sold-out"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clip-rule="evenodd"
              />
            </svg>
            We have closed booking seats.</span
          >
          <div>
            <a href="#register" class="btn btnLarge reverse btnOutline">
              Keep Me Updated<span class="btn-stroke"></span
            ></a>
          </div>
        </div>
      </div>
      <div class="bannerEvent__rgt">
        <div class="js-tilt">
          <svg
            width="386"
            height="472"
            viewbox="0 0 386 472"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M270.339 123.822L261.874 108.394L320.037 45.4188L318.827 43.2148L234.465 58.4366L226 43.0085L317.284 27.335L332.601 55.2524L270.339 123.822Z"
              fill="#18FB8E"
            />
            <path
              d="M16.2268 125.162C14.397 121.827 13.9504 118.553 14.887 115.339C15.8571 112.01 18.0097 109.431 21.3448 107.601L36.0194 99.5501L43.3387 112.891L34.3339 117.831C32.3328 118.929 31.9422 120.59 33.1621 122.813L49.5695 152.718C50.952 155.238 51.2753 157.761 50.5394 160.286C49.8776 162.77 48.2497 164.724 45.6557 166.147L44.9887 166.513L46.0866 168.514L46.7536 168.148C49.3476 166.725 51.8701 166.402 54.3211 167.178C56.8461 167.914 58.8 169.542 60.1825 172.062L76.5899 201.967C77.8098 204.19 79.4203 204.753 81.4214 203.655L90.4262 198.715L97.7455 212.055L83.071 220.106C79.7358 221.936 76.404 222.366 73.0755 221.396C69.8617 220.459 67.3399 218.324 65.5101 214.988L47.0289 181.304C45.8497 179.154 44.2595 178.629 42.2584 179.726L35.2546 183.569L26.4715 167.56L33.4753 163.718C35.4763 162.62 35.8873 160.996 34.708 158.847L16.2268 125.162Z"
              fill="#18FB8E"
            />
            <path
              d="M113.896 115.401C115.075 117.55 116.665 118.076 118.666 116.978L125.67 113.135L134.453 129.144L127.449 132.986C125.448 134.084 125.037 135.708 126.216 137.857L144.698 171.542C146.528 174.877 146.937 178.172 145.926 181.426C145.03 184.714 142.915 187.273 139.58 189.103L124.905 197.154L117.586 183.813L126.591 178.873C128.592 177.775 128.982 176.114 127.762 173.891L111.355 143.986C109.972 141.466 109.612 138.964 110.274 136.48C111.01 133.954 112.675 131.98 115.269 130.557L115.936 130.191L114.838 128.19L114.171 128.556C111.577 129.979 109.017 130.323 106.492 129.587C104.041 128.81 102.125 127.162 100.742 124.642L84.3346 94.7372C83.1147 92.5138 81.5042 91.9511 79.5031 93.049L70.4983 97.9895L63.179 84.649L77.8536 76.5977C81.1887 74.7679 84.4835 74.3584 87.7379 75.3691C91.0257 76.2651 93.5846 78.3806 95.4144 81.7158L113.896 115.401Z"
              fill="#18FB8E"
            />
            <path
              d="M340.146 230.5L333.342 253.846L327.409 263.342L329.393 264.928L335.786 258.3L358.912 245.612L365.68 257.946L342.553 270.634L333.528 272.466L333.8 274.991L344.997 275.088L368.343 281.892L364.399 295.423L341.053 288.618L331.557 282.685L329.972 284.669L336.599 291.062L349.288 314.189L336.954 320.956L324.265 297.829L322.434 288.805L319.909 289.076L319.811 300.273L313.007 323.619L299.477 319.676L306.281 296.33L312.215 286.834L310.231 285.248L303.838 291.876L280.711 304.564L273.944 292.23L297.07 279.542L306.095 277.71L305.824 275.185L294.627 275.088L271.281 268.284L275.224 254.753L298.57 261.558L308.066 267.491L309.652 265.507L303.024 259.114L290.336 235.987L302.67 229.22L315.358 252.347L317.189 261.371L319.715 261.1L319.812 249.903L326.616 226.557L340.146 230.5Z"
              fill="#18FB8E"
            />
            <path
              d="M187.768 434.625C185.553 430.588 185.074 426.414 186.331 422.102C187.65 417.575 190.328 414.204 194.365 411.989C198.402 409.774 202.615 409.365 207.002 410.761C211.453 411.941 214.786 414.549 217.001 418.586L228.228 439.049C230.824 443.782 231.432 448.52 230.049 453.262C228.806 457.929 225.818 461.56 221.086 464.157L210.437 469.999L204.25 458.724L214.064 453.34C217.823 451.278 218.556 448.159 216.265 443.982L213.401 438.762C212.516 439.791 211.448 440.649 210.195 441.336C206.297 443.475 202.123 443.954 197.672 442.774C193.285 441.378 189.983 438.662 187.768 434.625ZM143.777 354.444C141.562 350.407 141.083 346.233 142.34 341.922C143.659 337.394 146.337 334.023 150.374 331.809C154.411 329.594 158.623 329.184 163.011 330.58C167.462 331.76 170.795 334.369 173.01 338.406C175.224 342.443 175.672 346.725 174.353 351.252C173.096 355.563 170.449 358.826 166.413 361.041C162.376 363.256 158.132 363.773 153.681 362.593C149.293 361.197 145.992 358.481 143.777 354.444Z"
              fill="#18FB8E"
            />
          </svg>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Banner",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
header {
  margin-top: 3rem;
}
.navbarTop {
  margin-bottom: 5rem;
}
.navbarTop img {
  max-width: 150px;
}
.hero-heading {
  font-size: 5rem;
  font-weight: 900;
  margin-bottom: 3rem;
  line-height: 1.2;
  color: var(--text-white);
}
.text-outline {
  -webkit-text-stroke: 1.5px var(--text-white);
  color: var(--bg-black);
}
.bannerEvent {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas:
    "bannerEvent__lft bannerEvent__lft bannerEvent__lft bannerEvent__rgt"
    "bannerEvent__lft bannerEvent__lft bannerEvent__lft bannerEvent__rgt"
    "bannerEvent__lft bannerEvent__lft bannerEvent__lft bannerEvent__rgt";
  grid-gap: 30px;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-bottom: 9rem;
}
.bannerEvent__lft {
  grid-area: bannerEvent__lft;
}
.rgtAbout {
  grid-area: bannerEvent__rgt;
}
.bannerevent__lft h2 {
  font-weight: normal;
  margin-bottom: 5.25rem;
}
.bannerEvent__lft h2 span {
  background-color: var(--grey-textbg);
}
.bannerEvent h2 {
  color: var(--text-white);
  font-weight: lighter;
}
.hero-timing {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary-color);
  margin-bottom: 1rem;
}
.bannerEvent__register h1 {
  color: var(--text-grey);
  margin-bottom: 16px;
}
.bannerEvent__register .sold-out {
  color: var(--lighter-grey);
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
}
.bannerEvent__register .sold-out svg{
  width: 20px;
  height: 20px;
  margin-right: 0.5rem;
}
.bannerEvent__register > div {
  display: flex;
}
.bannerEvent__register > div .btn {
  margin-right: 30px;
}
@media (max-width: 768px) {
  .bannerEvent h2,
  .bannerEvent__register h1 {
    text-align: center;
  }
  .bannerEvent__register > div {
    flex-direction: column;
  }
  .bannerEvent__register > div a {
    margin-top: 25px;
  }
  .bannerEvent__register .btn div {
    justify-content: center;
  }
  .pageFooter__wrapper {
    flex-direction: column;
  }
  .hero-heading {
    font-size: 3rem;
    line-height: 1.3;
    margin-top: 20px;
  }
}
@media screen and (max-width: 992px) {
  .bannerEvent__rgt {
    display: none;
  }
  .bannerEvent {
    grid-template-areas:
      "bannerEvent__lft bannerEvent__lft bannerEvent__lft bannerEvent__lft  "
      "bannerEvent__lft bannerEvent__lft bannerEvent__lft bannerEvent__lft  "
      "bannerEvent__lft bannerEvent__lft bannerEvent__lft bannerEvent__lft  ";
    text-align: center;
  }
  .navbarTop img {
    margin: auto;
  }
  .bannerEvent__register a.btn {
    margin: auto;
  }
  .navbarTop {
    margin-bottom: 3rem;
  }
}
@media (max-width: 576px) {
  .bannerEvent {
    margin-bottom: 6rem;
  }
}
</style>
